import { Timestamp } from '@britishcouncil/common-core';
import {
  CentreTypeSelector,
  api,
  MonitoringDueReportResponse,
  PagedResultOfMonitoringDueReportResponse,
} from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';
import { TableState } from 'types';
import { MonitoringDueReportFilterType } from './MonitoringDueReportTypes';
import {
  getBcCentresIds,
  getIdpCentresIds,
  getPaginationParameters,
  getQueryStringParameters,
} from 'utils';

type ReportParams = TableState<MonitoringDueReportResponse, MonitoringDueReportFilterType>;
const mapQueryParams = (params: ReportParams) => {
  if (params.filters.date?.[0] == undefined || params.filters.date[1] == undefined) {
    throw new Error('From and To dates are required');
  }

  return {
    ...getPaginationParameters(params),
    filter: {
      startDate: Timestamp.toISOString(params.filters.date[0]),
      endDate: Timestamp.toISOString(params.filters.date[1]),
      monitoringTypes: params.filters.monitoringTypes ?? [],
      regions: params.filters.regionsIds ?? [],
      countries: params.filters.countriesIds ?? [],
      centres: getBcCentresIds(params.filters.centresIds),
      idpCentres: getIdpCentresIds(params.filters.centresIds),
      centreType: params.filters.centreType ?? CentreTypeSelector.ALL,
    },
  };
};

export const monitoringDueReportApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getMonitoringDueRecords: builder.query<PagedResultOfMonitoringDueReportResponse, ReportParams>({
      query: (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.monitoringsDueReport.getMonitoringDueReport(input);
      },
    }),
    generateMonitoringDuePdfReport: builder.mutation<File, ReportParams>({
      query: async (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.monitoringsDueReport.getMonitoringDuePdfReport(input, {
          format: 'arraybuffer',
        });
      },
    }),
    generateMonitoringDueExcelReport: builder.mutation<File, ReportParams>({
      query: (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.monitoringsDueReport.getMonitoringDueExcelReport(input, {
          format: 'arraybuffer',
        });
      },
    }),
  }),
});

export const {
  useGetMonitoringDueRecordsQuery,
  useGenerateMonitoringDuePdfReportMutation,
  useGenerateMonitoringDueExcelReportMutation,
} = monitoringDueReportApi;
